/** EUR formatting from minor units with optional precision (Vue formatEur). */
export function formatEur(amountValue: number, precision = 2): string {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(amountValue / 10 ** precision);
}
